module.exports = __webpack_public_path__ + "img/tu3.8a4e1ae6.png";